import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationAlertLevel } from '../notification-alert-level.enum';
import { SnackbarNotificationComponent, SnackbarNotificationsData } from './snackbar-notification.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarNotificationService {

  constructor(private readonly snackBar: MatSnackBar) { }

  open(alertLevel: NotificationAlertLevel, message: string | undefined = undefined) {

    switch (alertLevel) {
      case NotificationAlertLevel.Success: this.openSuccess(message ?? ''); break;
      case NotificationAlertLevel.Warning: this.openWarning(message ?? ''); break;
      case NotificationAlertLevel.Error: this.openError(message); break;
      default: this.openWarning(message ?? ''); break;
    }

  }

  openSuccess(message: string) {
    this.snackBar.openFromComponent(SnackbarNotificationComponent, {
      duration: 3000,
      data: {
        icon: 'check_circle',
        message: message,
      } as SnackbarNotificationsData,
      panelClass: 'success-snackbar'
    })
  }

  openInfo(message: string) {
    this.snackBar.openFromComponent(SnackbarNotificationComponent, {
      duration: 5000,
      data: {
        icon: 'info',
        message: message,
      } as SnackbarNotificationsData,
      panelClass: 'info-snackbar'
    })
  }

  openWarning(message: string) {
    this.snackBar.openFromComponent(SnackbarNotificationComponent, {
      duration: 5000,
      data: {
        icon: 'warning',
        message: message,
      } as SnackbarNotificationsData,
      panelClass: 'warning-snackbar'
    })
  }

  openError(message: string | undefined = undefined) {
    this.snackBar.openFromComponent(SnackbarNotificationComponent, {
      duration: 5000,
      data: {
        icon: 'error',
        message: message ?? 'errore',
      } as SnackbarNotificationsData,
      panelClass: 'error-snackbar'
    })
  }

}
